import { render, staticRenderFns } from "./user-editor.vue?vue&type=template&id=6d516c93&scoped=true&"
import script from "./user-editor.vue?vue&type=script&lang=js&"
export * from "./user-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d516c93",
  null
  
)

export default component.exports